/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config/animation";

const CoursesOffered = () => {
  return (
    <motion.div
      variants={animation}
      className="py-6 xl:py-12 lg:py-12 bg-primary bg-opacity-10 shadow-inner"
    >
      <div className="container">
        <h2 className="text-2xl xl:text-3xl lg:text-3xl font-source font-bold text-black tracking-tight">
          Courses Offered
        </h2>
        <div className="mt-5 grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-y-5 xl:gap-5 lg:gap-5">
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
              <h5 className="text-lg font-source font-semibold text-black">
                Real Estate Principles Course
              </h5>
              <p className="mt-1 text-base font-source font-normal text-greyText">
                Provides an extensive knowledge of basic concepts and real
                estate practices while establishing industry basics.​
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
              <h5 className="text-lg font-source font-semibold text-black">
                Real Estate Finance Course
              </h5>
              <p className="mt-1 text-base font-source font-normal text-greyText">
                Offers a complete examination of financial instruments and
                investment analysis alongside economic real estate market
                influences.​
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
              <h5 className="text-lg font-source font-semibold text-black">
                Real Estate Practice Course
              </h5>
              <p className="mt-1 text-base font-source font-normal text-greyText">
                Teaches day-to-day operational skills of real estate
                professionals by combining client interaction with property ad
                along with transaction handling skills.
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CoursesOffered;
